export default __webpack_public_path__ + "static/media/Code-of-Conduct-2022.1a455d9c.pdf";